import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

export function DropdownPortal({ children }: { children: ReactNode }) {
  return createPortal(children, document.body);
}
